import state from "./ssoState";
import mutations from "./ssoMutations";
import getters from "./ssoGetters";
import actions from "./ssoActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
